export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "sections",
      layout: "dashboard",
    },
    path: "/sections",
    name: "sections",
    component: () => import("@/layouts/index/ItemsIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "sections",
          layout: "dashboard",
        },
        path: "index",
        name: "sections-index",
        component: () => import("@/views/sections/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Creer un produit",
          layout: "dashboard",
        },
        path: "create",
        name: "sections-create",
        component: () => import("@/views/sections/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un produit",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "sections-edit",
        component: () => import("@/views/sections/Edit.vue"),
      },
    ],
  },
];
